const RoleBadge = ({ children }) => (
  <span className="inline-flex items-center px-2.5 py-0.5 rounded-md text-[10px] font-bold tracking-wider uppercase bg-white/15 text-white border border-white/20">
    {children}
  </span>
);

export default RoleBadge;
